<template>
  <div class="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-white/85 backdrop-blur-sm">
    <div class="max-w-[300px] text-center p-8">
      <LockIcon class="mx-auto mb-3 size-5 text-muted-foreground" />
      <p class="text-xs font-medium text-muted-foreground leading-relaxed">{{ message }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LockIcon } from 'lucide-vue-next'

defineProps<{ message: string }>()
</script>
